import React, { useEffect } from 'react'
import { Paper } from '@mui/material';
// import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
// import AddRecruiterForm from '../form/addRecruiter';
// import AddBlogForm from '../form/addBlogForm';
import { useNavigate } from 'react-router-dom';
import api from '../../API/api';
import AchievementTable from '../table/achievment';
import AchievmentForm from '../form/achievmentForm';
import Swal from 'sweetalert2'



const Achievement = () => {

    // const navigation = useNavigate();

    const [open, setOpen] = React.useState(false);
    const [modalData, setModalData] = React.useState();
    const [achievment, setAchievment] = React.useState();

    const handleClickOpen = (data) => {
        setOpen(true);
        setModalData(data);
        // console.log(data,'csanjcnsaj');
    };
    const handleClose = () => {
        setOpen(false);
    };
    function handleDelete(data){
// console.log(data,'delete id');
deleteAchivement(data.id)
    }

    function getAchievment() {
        api.getAchievment().then(res => {
            // console.log(res, 'check red');
            setAchievment(res.data)
        }).catch(err => {
            // console.log(err, 'dashijdhasoiu');
        })
    }

    useEffect(() => {
        getAchievment();
    }, [])

    function deleteAchivement(id){
      api.deleteAchivement(id).then(res => {
        // console.log(res , 'res');
        if (res.status == 200) {   
            Swal.fire({
                title: 'Success',
                text: 'Achievement Added Successfully',
                icon: 'success',
                confirmButtonText: 'Ok'
            })
        }
        window.location.reload();       
      }).catch(err => {
        // console.log(err,'dsa');
      })
    }

    // console.log(modalData && modalData ,'modalData');


    return (
        <>
            <div className="row">
                <Paper elevation={3}>
                    <div className="col-12 d-flex justify-content-between p-2">
                        <div> <h3> Achievement</h3></div>
                    </div>
                    <FormDialog
                        form={<AchievmentForm
                            handleClose={handleClose}
                            handleClickOpen={handleClickOpen}
                            modalData={modalData}
                            type={'faculty'}
                            edit='yes'
                        />}
                        title='Add Achievement' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} size={'md'} />
                </Paper>

                <Paper>
                    <div className="col-12">
                        <AchievementTable data={achievment} handleClickOpen={handleClickOpen} valueType="table" handleDelete={handleDelete} />
                    </div>
                </Paper>
            </div>
        </>
    )
}

export default Achievement;